import {
  isMediaCardString,
  keyToMediaCardType,
  MediaCardString,
  MediaCardType,
} from '@wandb/weave/common/types/media';
import {isNotNullOrUndefined} from '@wandb/weave/common/util/types';
import {useCallback, useMemo} from 'react';

import {useKeyInfoQueryContext} from '../MultiRunWorkspace/KeyInfoQueryContext';
import {getMediaKeys} from './utils/getMediaKeys';

export const useGetMediaCardTypes = (
  mediaKeys: string[] | undefined
): (() => MediaCardType[] | undefined) => {
  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();
  return useCallback(() => {
    const {keyTypes} = getMediaKeys(keyInfo);
    const mediaCardTypes = mediaKeys
      ?.map(key => (key != null ? keyTypes[key] : null))
      ?.filter(
        (mediaString): mediaString is MediaCardString =>
          isNotNullOrUndefined(mediaString) && isMediaCardString(mediaString)
      )
      ?.map(keyToMediaCardType);
    return mediaCardTypes;
  }, [mediaKeys, keyInfo]);
};

export const useMediaCardTypes = (mediaKeys: string[] | undefined) => {
  const getMediaCardTypes = useGetMediaCardTypes(mediaKeys);
  return useMemo(() => getMediaCardTypes(), [getMediaCardTypes]);
};
